//
//
//
//
//
//
//
//

export default {
  props: {
    txts: {
      // 滚动文本
      type: String,
      default: "",
    },
    marqueeId: {
      // 滚动组件id
      type: String,
      default: "marquee1",
    },
    speed: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      timer: null,
      leftN: "1000",
    };
  },
  watch: {
    txts(v) {
      if (v !== "") {
        this.$nextTick(() => {
          this.marquee();
        });
      }
    },
  },
  mounted() {},
  activated() {
    this.$nextTick(() => {
      if (this.txts !== "") this.marquee();
    });
  },
  deactivated() {
    clearInterval(this.timer);
  },
  methods: {
    marquee() {
      let wrap = document.getElementById(this.marqueeId);
      let inner = wrap.getElementsByTagName("*")[0];
      const a = Math.ceil(wrap.clientWidth);
      const b = Math.ceil(inner.clientWidth);
      this.leftN = a;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.leftN--;
        if (this.leftN < -200 - b) {
          clearInterval(this.timer);
          this.marquee();
        }
      }, this.speed);
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
};



// WEBPACK FOOTER //
// ./src/common/components/g-marquee/index.vue